var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"list-filter-title"},[_vm._v(_vm._s(_vm.param.name))]),_c('el-input',{staticClass:"list__search",attrs:{"value":_vm.value,"placeholder":_vm.param.name},on:{"input":_vm.filterChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }